import { FC } from 'react';
import { StackHeaderProps } from '@react-navigation/stack';
import { headerFactory } from '../../../components';
import { ScannedEmployeeHeaderTitle } from './ScannedEmployeeHeaderTitle';

export const ScannedEmployeeHeader: FC<StackHeaderProps> = (props: StackHeaderProps) =>
  headerFactory(props, ScannedEmployeeHeaderTitle);
